export const taxonomy_queries = `category 
{
  categories
}
cause {
  causes
}`;
